module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "connect"
  }, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent,
      "activeTo": "Contect"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "mogos"
  }, [_c('div', {
    staticClass: "mogos-wrap"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "cart-content"
  }, [_c('h1', {
    staticClass: "font-big"
  }, [_vm._v("MOGO S")]), _vm._v(" "), _c('p', {
    staticClass: "font-mid"
  }, [_vm._v(_vm._s(_vm.$t('connect_content1')))])]), _vm._v(" "), _c('div', {
    staticClass: "connect_btn"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/product/mogos',
        query: {
          id: 1
        }
      }
    }
  }, [_c('button', {
    staticClass: "font-small"
  }, [_vm._v(" " + _vm._s(_vm.$t('home_mogos_get')))])])], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "iglobal"
  }, [_c('div', {
    staticClass: "iglobal-wrap"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "cart-content"
  }, [_c('h1', {
    staticClass: "font-big"
  }, [_vm._v("iGlobal")]), _vm._v(" "), _c('p', {
    staticClass: "font-mid"
  }, [_vm._v(_vm._s(_vm.$t('connect_content2')))])]), _vm._v(" "), _c('div', {
    staticClass: "connect_btn"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/product/iglobal/?id=9'
      }
    }
  }, [_c('button', {
    staticClass: "font-small"
  }, [_vm._v(_vm._s(_vm.$t('connect_more')))])])], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "iapp"
  }, [_c('div', {
    staticClass: "iapp-wrap"
  }, [_c('h1', {
    staticClass: "font-big"
  }, [_vm._v("iAPP")]), _vm._v(" "), _c('p', {
    staticClass: "font-mid"
  }, [_vm._v(_vm._s(_vm.$t('connect_content3')))]), _vm._v(" "), _c('div', {
    staticClass: "connect_btn"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'app'
      }
    }
  }, [_c('button', {
    staticClass: "font-small"
  }, [_vm._v(_vm._s(_vm.$t('connect_download')))])])], 1), _vm._v(" "), _vm._m(2, false, false)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "ivoice"
  }, [_c('div', {
    staticClass: "ivoice-wrap"
  }, [_c('h1', {
    staticClass: "font-big"
  }, [_vm._v("iVoice")]), _vm._v(" "), _c('p', {
    staticClass: "font-mid"
  }, [_vm._v(_vm._s(_vm.$t('connect_content4')))]), _vm._v(" "), _c('div', {
    staticClass: "connect_btn"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'iVoice'
      }
    }
  }, [_c('button', {
    staticClass: "font-small"
  }, [_vm._v(_vm._s(_vm.$t('connect_more')))])])], 1), _vm._v(" "), _vm._m(3, false, false)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('BackTop', [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/top.png")
    }
  }), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(_vm.$t('top_btn')))])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://ifree.ly/support",
      "target": "_blank"
    }
  }, [_c('BackTop', {
    attrs: {
      "height": 100,
      "bottom": 110
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/service.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Service_btn')))])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/connect/mogos@2x.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/connect/iGlobal@2x.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iapp-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/connect/iapp_en@2x.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ivoice-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/home/new_home/ivoice_global.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06ff5aec","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Connect/Connect.vue
// module id = 776
// module chunks = 0